import { get } from "lodash";

const getFreezeActionPending = state =>
  Boolean(get(state, "factoringClient.freezeActionPending", false));

export default getFreezeActionPending;
